import PageLoader from 'app/components/PageLoader';
import PaginatedTable from 'app/components/table/PaginationTable';
import DeletionBucketSection from 'app/components/DeletionBucketSection';
import { CustomerPrivilegeHeader } from 'app/constants/table-header-constants';
import { ParseTableDate } from 'app/utils/Parsers';
import useCustomerPrivilege from './useCustomerPrivilege';
import CollectPrivilege from './CollectPrivilege';

const CustomerPrivilege = ({ latestDeletionDate, latestRestorationDate }) => {
  const {
    pageLoading,
    dataPerPage,

    flatData,
    flatTotal,
    flatPageCount,
    fetchFlat,

    afterData,
    beforeData,

    handleNew,
    isFilterOpen,
    setIsFilterOpen,
    values,
    setValues,
    handleSubmit,
  } = useCustomerPrivilege(latestDeletionDate);

  const collectModal = isFilterOpen && (
    <CollectPrivilege
      isFilterOpen={isFilterOpen}
      setIsFilterOpen={setIsFilterOpen}
      onSubmit={handleSubmit}
      values={values}
      setValues={setValues}
    />
  );

  // Never-deleted: single flat list (Influencer catalog for current tier).
  if (!latestDeletionDate) {
    return (
      <>
        <div className='cms-content__container'>
          <PaginatedTable
            columns={CustomerPrivilegeHeader}
            data={flatData}
            currentPage={1}
            dataPerPage={dataPerPage}
            totalNumber={flatTotal}
            pageCount={flatPageCount}
            pageLoading={pageLoading}
            handleNew={handleNew}
            fetchData={fetchFlat}
          />
        </div>
        {collectModal}
        {pageLoading === true && <PageLoader pageLoading={pageLoading} />}
      </>
    );
  }

  const restorationFormatted = latestRestorationDate
    ? ParseTableDate(latestRestorationDate)
    : undefined;
  const deletionFormatted = ParseTableDate(latestDeletionDate);

  return (
    <>
      <div className='cms-content__container'>
        {/* Restored: collectable, counts reset to the current Influencer cycle */}
        <DeletionBucketSection
          title='Account restored'
          captionDate={restorationFormatted}
          captionPrefix='Account restored on'
          isEmpty={afterData.length === 0}
        >
          <PaginatedTable
            columns={CustomerPrivilegeHeader}
            data={afterData}
            currentPage={1}
            // Privileges aren't server-paginated — the whole catalog (~23 rows)
            // comes back at once, so show it on a single page (no pagination).
            dataPerPage={afterData.length || 1}
            totalNumber={afterData.length}
            pageLoading={pageLoading}
            handleNew={handleNew}
          />
        </DeletionBucketSection>

        {/* Deleted: read-only history of privileges used before deletion */}
        <DeletionBucketSection
          title='Account deleted'
          captionDate={deletionFormatted}
          isEmpty={beforeData.length === 0}
        >
          <PaginatedTable
            columns={CustomerPrivilegeHeader}
            data={beforeData}
            currentPage={1}
            dataPerPage={beforeData.length || 1}
            totalNumber={beforeData.length}
            pageLoading={pageLoading}
          />
        </DeletionBucketSection>
      </div>
      {collectModal}
      {pageLoading === true && <PageLoader pageLoading={pageLoading} />}
    </>
  );
};

export default CustomerPrivilege;
